import { clamp, easeOutCubic, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createApex(): DrawFn {
  const rng = mulberry32(365)
  const field = Array.from({ length: 90 }, () => ({
    x: rng(),
    y: rng(),
    s: 0.4 + rng() * 1.6,
    o: rng() * TAU,
  }))
  const shooting = Array.from({ length: 4 }, () => ({
    delay: 1.2 + rng() * 3.5,
    dur: 0.65 + rng() * 0.35,
    y: 0.1 + rng() * 0.28,
    x: rng() * 0.45,
  }))

  return (ctx, t, w, h) => {
    ctx.clearRect(0, 0, w, h)
    const intro = easeOutCubic(clamp(t / 1.2))
    ctx.globalCompositeOperation = 'lighter'

    for (const s of field) {
      const tw = 0.25 + 0.75 * (0.5 + 0.5 * Math.sin(t * 2.6 + s.o))
      ctx.fillStyle = `rgba(230,240,255,${tw * 0.55 * intro})`
      ctx.beginPath()
      ctx.arc(s.x * w, s.y * h, s.s, 0, TAU)
      ctx.fill()
    }

    const apexX = w * 0.5
    const apexY = h * 0.26
    const pulse = 0.75 + Math.sin(t * 1.8) * 0.25
    glow(ctx, apexX, apexY, 36 * pulse, `rgba(255,230,160,${0.18 * intro})`)

    for (const s of shooting) {
      const cycle = 5.5
      const local = (t - s.delay + cycle * 8) % cycle
      if (local < 0 || local > s.dur) continue
      const u = local / s.dur
      const x = (s.x + u * 0.7) * w
      const y = (s.y + u * 0.18) * h
      const g = ctx.createLinearGradient(x - 56, y - 16, x, y)
      g.addColorStop(0, 'rgba(255,240,200,0)')
      g.addColorStop(1, `rgba(255,240,200,${(1 - u) * 0.85})`)
      ctx.strokeStyle = g
      ctx.lineWidth = 1.4
      ctx.beginPath()
      ctx.moveTo(x - 56, y - 16)
      ctx.lineTo(x, y)
      ctx.stroke()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
